import {Component, OnDestroy, OnInit} from '@angular/core';

import {Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectService,
  TenantService,
  UserService,
} from '../../_services/index';

import { Company, Project, User, LLMProvider } from '../../_models/index';

import {CompanyType, Role} from '../../helpers/index';

import {saveAs as importedSaveAs} from "file-saver";

import {LoginHelper} from '../../helpers';
import { MatDialog } from '@angular/material/dialog';
import {AccountCreatedMessageComponent} from "../accountCreatedMessage";
import {TrainingService} from "../../_services/training.service";
import {forkJoin, Subscription} from 'rxjs';
import {TenantPermissionsService} from "../../_services/tenantPermissions.service";
import {MessageComponent} from "../message";
import {ConfirmComponent} from "../confirm";
import {IndexConfigService} from "../../_services/index.config.service";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {OidcService} from "../../_services/oidc.service";
import {Constants} from "../../helpers/constants";
import { EncryptHelper } from '../../helpers';
import { ViewChild, TemplateRef } from '@angular/core';
import {ThemePalette, ThemePaletteService, ThemePaletteColors, ThemeMode} from "../../core/services/theme-palette.service";

@Component({
    standalone: false,
  selector: "client-profile",
  templateUrl: 'client.profile.component.html',
  styleUrls: ['./client.profile.component.scss']
})

export class ClientProfileComponent implements OnInit, OnDestroy {

  model: any;

  @ViewChild('ackDialog') ackDialog: TemplateRef<any>;

  dialogRef: any;
  loading = false;
  currentUser: User;
  selectedActiveLlmId: number;

  isFirstLogin: boolean = false;
  llmProviders: LLMProvider[] = [];
  trainingResults = [];
  trainings = [];
  color = "#222222";
  defaultProject: number;
  projects: Project[];
  originalManagerEmail: string;
  originalAdvisorEmail: string;
  isClientManager: boolean;
  tenant = null;
  tenantName: string = LoginHelper.getTenantName();
  userToken: string = LoginHelper.getUserToken();
  firstLoginNotice: string = '';
  firstLoginNoticeEnabled: any;
  themePalette: ThemePalette;
  borderStrength = 0.1;
  loginLogoUrl: string;
  loginImageUrl: string;
  isElixirEnabled: boolean;
  labels = [
    'Govern',
    'Operate',
    'Dashboard',
    'Projects',
    'Profiles',
    'System',
    'Systems',
    'SAP',
    'SAR',
    'ConMon',
    'Workstreams',
    'Forms',
    'Demonstrate',
    'Policies',
    'Documents',
    'Library',
    'Directives',
    'Request Lists',
    'RizkList',
    'IR',
    'Awareness',
    'Audit Prep',
    'Trust Builder',
    'Admin',
    'Tenants',
    'Integrations',
    'Logging',
    'Controls',
    'Users',
    'The Vault',
  ];
  constants = Constants;

  private themePaletteSub: Subscription;

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public userService: UserService,
    public authenticationService: AuthenticationService,
    public clientProfileService: ClientProfileService,
    public fileBlobService: FileBlobService,
    public alertService: AlertService,
    public tenantService: TenantService,
    public trainingService: TrainingService,
    public tenantPermissionsService: TenantPermissionsService,
    public projectService: ProjectService,
    public oidcService: OidcService,
    public config: IndexConfigService,
    public themePaletteService: ThemePaletteService
  ) {
    this.themePalette = this.themePaletteService.palette;
    this.borderStrength = this.themePaletteService.borderStrengthValue;
  }

  ngOnInit() {
    this.themePaletteSub = this.themePaletteService.palette$.subscribe(palette => {
      this.themePalette = {
        mode: palette.mode,
        colors: { ...palette.colors },
        chartPalette: [...palette.chartPalette],
      };
      this.borderStrength = this.themePaletteService.borderStrengthValue;
      this.syncThemePaletteToSettings();
    });
    this.loadData();
  }

  ngOnDestroy() {
    this.themePaletteSub?.unsubscribe();
  }

  loadData() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.tenantService.getCurrent().subscribe(t => this.tenant = t);
    //console.log("current user id", LoginHelper.getUserId());
    this.isFirstLogin = location.href.indexOf('firstlogin') > 0;
    this.userService.getById(LoginHelper.getUserId()).subscribe(u => {
      const userId = Number(u.userId || LoginHelper.getUserId());
      console.log("Loading " + JSON.stringify(u));
      this.llmProviders = (u.llmProviders && u.llmProviders.length > 0)
        ? u.llmProviders.map((p: any) => ({
          id: Number(p.id) || 0,
          userId: userId,
          provider: p.provider || '',
          encryptedApiKey: p.encryptedApiKey || '',
          isActive: p.isActive ?? false
        }))
        : [{
          id: 0,
          userId: userId,
          provider: '',
          encryptedApiKey: '',
          isActive: true
        }];


      const activeLlm = u.llmProviders.find(llm => llm.isActive);
      if (activeLlm) {
        this.selectedActiveLlmId = activeLlm.id;
      }

      this.tenantService.getCurrent().subscribe(t => {
        this.isElixirEnabled = t?.isElixirEnabled;
      });

      if (this.isFirstLogin && !u.active && !localStorage.getItem('agreed')) {
        this.tenantPermissionsService.getCurrentTenantPermissions().subscribe(p => {
          if (p != null && p.loginAlert != null) {
            let dialogRef = this.dialog.open(MessageComponent,
              {
                width: '250px',
                data: {title: '', text: p.loginAlert, button: 'I Agree'}
              });
            dialogRef.afterClosed().subscribe(r => {
              if (r === true) {
                localStorage.setItem('agreed', "value");
              }
            });
          }
        })
      }
    })

    this.model = {};

    this.model.systemOwner = {};
    this.model.manager = new User(0);
    this.model.manager.role = Role.PrimaryManager;
    this.model.manager.firstName = "Please";
    this.model.manager.lastName = "Enter";

    this.model.advisorLead = new User(0);
    this.model.advisorLead.role = Role.PrimaryAdvisorLead;
    this.model.advisorLead.firstName = "Please";
    this.model.advisorLead.lastName = "Enter";


    this.model.clientCompany = new Company();
    this.model.clientCompany.companyType = CompanyType.Client;

    this.model.consultantCompany = new Company();
    this.model.consultantCompany.companyType = CompanyType.Advisor;
    this.model.consultantCompany.logoFileName = 'rizkly_logo.png';

    this.model.settings = {};
    this.model.dbSettings = {};

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isClientManager = (this.currentUser.role & Role.PrimaryManager) != 0;

    this.userService.getManagers(tenantName).subscribe(managersInfo => {
        if (this.tenantName !== Constants.RiskSpongeMaster) {
          if (managersInfo.manager) {
            this.model.manager = managersInfo.manager;
          }
          this.originalManagerEmail = this.model.manager.emailAddress;
          if (managersInfo.advisorLead) {
            this.model.advisorLead = managersInfo.advisorLead;
          }
          this.originalAdvisorEmail = this.model.advisorLead.emailAddress;
          if (managersInfo.clientCompany) {
            this.model.clientCompany = managersInfo.clientCompany;
          }
          if (managersInfo.consultantCompany) {
            this.model.consultantCompany = managersInfo.consultantCompany;
            this.model.consultantCompany.logoFileName = this.model.consultantCompany.logoFileName || 'rizkly_logo.png';
          }
          if (managersInfo.dbSettings) {
            this.model.dbSettings = managersInfo.dbSettings;
          }
          this.model.ownDataStorageType = managersInfo.dbSettings.postgressServer ? 1 : 0;
        }
        if (managersInfo.settings) {
          this.model.settings = managersInfo.settings;
          this.firstLoginNoticeEnabled = this.model.settings.firstLoginNotice;
          this.themePaletteService.applyFromSettings(this.model.settings);
        }
        if (managersInfo.dbSettings) {
          this.model.dbSettings = managersInfo.dbSettings;
        }
        this.model.ownDataStorageType = managersInfo.dbSettings.postgressServer ? 1 : 0;
          this.loginLogoUrl = '/api/attachments/file?name=' + encodeURIComponent(this.model.settings.loginLogo) + '&path=' + encodeURIComponent('Account/System/') + '&token=' + LoginHelper.getFileToken();
          this.loginImageUrl = '/api/attachments/file?name=' + encodeURIComponent(this.model.settings.loginImage) + '&path=' + encodeURIComponent('Account/System/') + '&token=' + LoginHelper.getFileToken();

      console.log(managersInfo);
      if (managersInfo.LlmProviders) {
        this.llmProviders = managersInfo.LlmProviders;
       }
      },
      error => {
        const errorMessage = 'An error occurred while loading managers information.';
        this.alertService.error(errorMessage);
      });
    forkJoin(
      this.userService.getAll(),
      this.trainingService.getTrainingResults(),
      this.trainingService.getAllTrainings())
      .subscribe(data => {
        let users = data[0];
        let results = data[1];
        this.trainings = data[2];
        let affectedUsers = users.filter(u => u.role == Role.Training).concat(results.map(r => users.find(u => u.userId == r.userId)));
        affectedUsers = affectedUsers.filter(function (item, pos) {
          return affectedUsers.indexOf(item) == pos
        });
        this.trainingResults = affectedUsers.map(u => {
          const row: any = {};
          row.fullName = (u.firstName || u.lastName) ? u.firstName + ' ' + u.lastName : u.emailAddress;
          for (let i = 0; i < this.trainings.length; i++) {
            const result = results.find(r => r.trainingId == this.trainings[i].id && r.userId == u.userId);
            if (result) {
              row['totalAnswers' + this.trainings[i].id] = result.totalAnswers;
              row['correctAnswers' + this.trainings[i].id] = result.correctAnswers;
              row['date' + this.trainings[i].id] = result.date;
            }
          }
          return row;
        });
      });

    this.projectService.getAll().subscribe(r => this.projects = r);
  }

  onSave() {
    if (this.tenantName !== Constants.RiskSpongeMaster) {
      if (!this.model.clientCompany.logoFileName) {
        this.alertService.error('Client company logo is required');
        return;
      } else if (!this.model.consultantCompany.logoFileName) {
        this.alertService.error('Advisory company logo is required');
        return;
      } else if (!this.model.clientCompany.companyName) {
        this.alertService.error('Client company name is required');
        return;
      } else if (!this.model.consultantCompany.companyName) {
        this.alertService.error('Advisory company name is required');
        return;
      } else if (!this.model.manager.emailAddress && !this.model.advisorLead.emailAddress) {
        this.alertService.error('At least one of client and advisor email address is required');
        return;
      }
    }

    if (this.model.ownDataStorageType == 0) {
      this.model.dbSettings.postgressServer = null;
      this.model.dbSettings.postgressDatabase = null;
      this.model.dbSettings.postgressUsername = null;
      this.model.dbSettings.postgressPassword = null;
    }

    let managerChanged = (this.model.manager.userId && this.model.manager.emailAddress != this.originalManagerEmail);
    let advisorChanged = (this.model.advisorLead.userId && this.model.advisorLead.emailAddress != this.originalAdvisorEmail);

    if (managerChanged || advisorChanged) {
      const currentUserAffected = ((this.originalManagerEmail.toLowerCase() === this.currentUser.emailAddress.toLowerCase() && this.model.manager.emailAddress.toLowerCase() !== this.currentUser.emailAddress.toLowerCase())
        || (this.originalAdvisorEmail.toLowerCase() === this.currentUser.emailAddress.toLowerCase() && this.model.advisorLead.emailAddress.toLowerCase() !== this.currentUser.emailAddress.toLowerCase()));
      this.dialog.open(ConfirmComponent, {
        data: {
          title: 'Do you wish to keep ' + (managerChanged ? '"' + this.originalManagerEmail + '" but as Manager' : '') + (managerChanged && advisorChanged ? ' and ' : '') + (advisorChanged ? '"' + this.originalAdvisorEmail + '" but as Lead Advisor' : '') + '?',
          subTitle: 'Existing project access rights will be transferred to the new admin.' + (currentUserAffected ? '<br>If "No" is selected current user will be deleted and logged out.' : ''),
          yes: 'Yes',
          no: 'No',
          confirm: (isChecked) => this.doOnSave(true, isChecked),
          cancel: (isChecked) => this.doOnSave(false, isChecked, currentUserAffected),
          close: 'Cancel'
        }
      });
    } else {
      this.doOnSave(false, false);
    }
  }

  doOnSave(preserveOld, transferProjects, logout = false) {
    this.model.preserveOld = preserveOld;
    this.model.transferProjects = transferProjects;
    //console.log("saving llms", this.llmProviders);
    this.llmProviders.forEach(p => {
      p.id = Number(p.id);
      p.encryptedApiKey =p.encryptedApiKey;
    });


    this.model.llmProviders = this.llmProviders;
    this.userService.updateManagers(this.model).subscribe(() => {
      if (this.isFirstLogin) {
        this.dialog.closeAll();
          let dialogRef = this.dialog.open(AccountCreatedMessageComponent,
            {
          width: '250px'
        });

          dialogRef.afterClosed().subscribe(result => {
            if (logout) {
              this.authenticationService.logout();
            } else {
              this.router.navigate(['/home']);
            }
          });
        } else {
          const message = 'Account Profile was updated';
          this.alertService.success(message);
          if (logout) {
            this.authenticationService.logout();
          } else {
            this.router.navigate(['/home']);
          }
        }
        localStorage.removeItem('agreed');
        this.loadData();
      },
      error => {
        const errorMessage = 'An error occurred while loading managers information.';
      this.alertService.error(errorMessage);
    });
  }

  public downloadFile(fileName: string) {
    this.fileBlobService.downloadFile(fileName, "")
      .subscribe(blob => {
          importedSaveAs(new Blob([blob]), fileName);
        },
        error => {
          const errorMessage = 'An error occurred while downloading file.';
          this.alertService.error(errorMessage);
        });
  }

  public addConsultantCompanyLogo(event) {

    let attachments = event.target.files;
    if (attachments.length > 0) {

      this.clientProfileService.uploadImageFile(attachments[0])
        .subscribe(data => {

          this.model.consultantCompany.logoFileName = data.name;
        });
    }
  }

  public addClientCompanyLogo(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {

      this.clientProfileService.uploadImageFile(attachments[0])
        .subscribe(data => {

          this.model.clientCompany.logoFileName = data.name;
        });
    }
  }

  public addLoginLogo(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {

      this.clientProfileService.uploadImageFile(attachments[0])
        .subscribe(data => {

          this.model.settings.loginLogo = data.name;
          this.loginLogoUrl = '/api/attachments/file?name=' + encodeURIComponent(data.name) + '&path=' + encodeURIComponent('Account/System/') + '&token=' + LoginHelper.getFileToken();
        });
    }
  }

  public addLoginImage(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {

      this.clientProfileService.uploadImageFile(attachments[0])
        .subscribe(data => {

          this.model.settings.loginImage = data.name;
          this.loginImageUrl = '/api/attachments/file?name=' + encodeURIComponent(data.name) + '&path=' + encodeURIComponent('Account/System/') + '&token=' + LoginHelper.getFileToken();
        });
    }
  }

  public downloadConsultantCompanyLogo() {

    this.downloadFile(this.model.consultantCompany.logoFileName);
  }

  public downloadClientCompanyLogo() {

    this.downloadFile(this.model.clientCompany.logoFileName);
  }

  firstLoginNoticeChanged($event: MatCheckboxChange) {
    if ($event.checked) {
      this.model.settings.firstLoginNotice = this.firstLoginNotice;
    } else {
      this.firstLoginNotice = this.model.settings.firstLoginNotice;
      this.model.settings.firstLoginNotice = '';
    }
  }


  generateId(): number { // do something later on that ensures uniqueness
    return Math.floor(Date.now() + Math.random() * 1000);
  }

  addNewLLM(): void {
    const newLlm: LLMProvider = {
      provider: '',
      encryptedApiKey: '',
      isActive: false
    };
    //console.log("Adding new LLM:" + LLMProvider);
    this.llmProviders.push(newLlm);
  }


  removeLLM(index: number): void {
    this.llmProviders.splice(index, 1);
  }

  onApiKeyChanged(llm: any): void {
    this.dialogRef = this.dialog.open(this.ackDialog);
    this.dialogRef.afterClosed().subscribe((result: boolean) => {
      //console.log("modified llm, ", llm);
      if (!result) {
        llm.encryptedApiKey = '';
      } else {
        llm.encryptedApiKey = EncryptHelper.reversibleEncrypt(llm.encryptedApiKey);
      }
    });
  }

  onActiveLlmChange(selectedId: number) {
    this.llmProviders.forEach(llm => {
      llm.isActive = (llm.id === selectedId);
    });
  }

  onThemeModeChange(mode: ThemeMode) {
    this.themePaletteService.setMode(mode);
  }

  onThemeColorChange(key: keyof ThemePaletteColors, color: string) {
    this.themePaletteService.updateColors({ [key]: color });
  }

  onChartPaletteChange(index: number, color: string) {
    const palette = [...this.themePalette.chartPalette];
    palette[index] = color;
    this.themePaletteService.setChartPalette(palette);
  }

  onBorderStrengthChange(value: number) {
    this.themePaletteService.setBorderStrength(value);
  }

  resetThemeDefaults() {
    this.themePaletteService.resetDefaults();
  }

  private syncThemePaletteToSettings(): void {
    if (!this.model?.settings) {
      return;
    }
    this.model.settings.themePalette = JSON.stringify(this.themePaletteService.getStorageSnapshot());
  }

}
